"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    counterBadgeClassNames: function() {
        return counterBadgeClassNames;
    },
    useCounterBadgeStyles_unstable: function() {
        return useCounterBadgeStyles_unstable;
    }
});
const _react = require("@griffel/react");
const _useBadgeStylesstyles = require("../Badge/useBadgeStyles.styles");
const counterBadgeClassNames = {
    root: 'fui-CounterBadge',
    icon: 'fui-CounterBadge__icon'
};
const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    dot: {
        Bf4jedk: "fgfkb25",
        a9b677: "f16dn6v3",
        Bqenvij: "f3mu39s",
        z8tnut: "f1g0x7ka",
        z189sj: [
            "fhxju0i",
            "f1cnd47f"
        ],
        Byoj8tv: "f1qch9an",
        uwmqm3: [
            "f1cnd47f",
            "fhxju0i"
        ]
    },
    hide: {
        mc9l5x: "fjseox"
    }
}, {
    d: [
        ".fgfkb25{min-width:auto;}",
        ".f16dn6v3{width:6px;}",
        ".f3mu39s{height:6px;}",
        ".f1g0x7ka{padding-top:0;}",
        ".fhxju0i{padding-right:0;}",
        ".f1cnd47f{padding-left:0;}",
        ".f1qch9an{padding-bottom:0;}",
        ".fjseox{display:none;}"
    ]
});
const useCounterBadgeStyles_unstable = (state)=>{
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(counterBadgeClassNames.root, state.dot && styles.dot, !state.root.children && !state.dot && styles.hide, state.root.className);
    if (state.icon) {
        state.icon.className = (0, _react.mergeClasses)(counterBadgeClassNames.icon, state.icon.className);
    }
    return (0, _useBadgeStylesstyles.useBadgeStyles_unstable)(state);
}; //# sourceMappingURL=useCounterBadgeStyles.styles.js.map
